const ACTIVITY_SUGGESTIONS = [

    "Feedback Received From Landlord",
    "Feedback Received From Tenant",
    "Feedback Received From Service Provider",
    "Feedback Received From Agent",
    "Feedback Received From Body Corporate",
    "Feedback Received From Caretaker",

    "Followed Up With Landlord",
    "Followed Up With Tenant",
    "Followed Up With Service Provider",
    "Followed Up With Agent",
    "Followed Up With Body Corporate",
    "Followed Up With Caretaker",

    "Phoned Landlord",
    "Phoned Tenant",
    "Phoned Service Provider",
    "Phoned Agent",
    "Phoned Body Corporate",
    "Phoned Caretaker",

    "Quote Requested From Landlord",
    "Quote Requested From Tenant",
    "Quote Requested From Service Provider",
    "Quote Requested From Agent",
    "Quote Requested From Body Corporate",
    "Quote Requested From Caretaker",

];

module.exports = {

    data () {
        return {
            ACTIVITY_SUGGESTIONS: ACTIVITY_SUGGESTIONS,
            defaultSuggestions : [],
        };
    },

    mounted(){
      this.defaultSuggestions = this.loadAll();
    },

    methods: {

        loadAll() {
            let activitySuggestions = [];
            for (var i = 0; i < this.ACTIVITY_SUGGESTIONS.length; i++) {
                activitySuggestions.push({ "value": this.ACTIVITY_SUGGESTIONS[i] });
            }

            return activitySuggestions;
        },

        searchActivitySuggestions(queryString, cb) {
            let defaultSuggestions = this.defaultSuggestions;
            let results = queryString ? defaultSuggestions.filter(this.createFilter(queryString)) : defaultSuggestions;
            cb(results);
        },

        createFilter (queryString) {
            return (suggestion) => {
                return (suggestion.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },

    }
};
